<template>
  <div class="show-archived-tenders-btn spacex-4">
    <Icon type="archive" size="16" />
    <div class="text-sm text-primary">{{ $t('Show archived tenders') }}</div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ShowArchivedButton',
    components: {
      Icon,
    },
  };
</script>
<style lang="scss">
  .show-archived-tenders-btn {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
</style>
